import { Dropdown, Space } from "antd";
import React, { Component } from "react";
import ProposalBloc from "../../../bloc/proposal_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import Config from "../../../Config";
import "./app_dropdown_action.css";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";
import App_notice_dialog from "../../dialog/app_notice_dialog/app_notice_dialog";
import ContactBloc from "../../../bloc/contact_bloc";
import AdminBloc from "../../../bloc/admin_bloc";
import AppTrackDialog from "../../dialog/app_notice_dialog/app_track_dialog";
import AppDeleteSignatureDialog from "../../dialog/app_notice_dialog/app_delete_signature_dialog";
import AppNoticeDialog from "../../dialog/app_notice_dialog/app_notice_dialog";
import AppDialog from "../app_dialog/app_dialog";

export default class DropDownAdminAction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mooduleConfig: {},
      isOpenDeleteDialog: false,
      isOpenTrackKey: Math.random()
    };
  }
  componentDidMount() {
    this.setState({
      moduleConfig: Config,
    });
  }

  stateConfig() {
    return this.state.moduleConfig;
  }

  stateItemId() {
    return this.props.id;
  }

  stateQuotationId() {
    return this.props.id;
  }

  stateQuotationIdByProposal() {
    return this.props.quotationId;
  }

  stateModule() {
    return this.props.module;
  }

  stateStatus() {
    return this.props.status;
  }

  getAssetsContextPath() {
    return "/myCUEPACSCare";
  }

  stateIsOpenDeleteDialog() {
    return this.state.isOpenDeleteDialog;
  }

  async onProceed() {
    let quotationId = this.stateQuotationId();
    this.setState({
      loading: true,
    });

    ProposalBloc.createNewProposal(quotationId)
      .then((result) => {
        if (result.success) {
          let proposalId = result.data[0].proposal.id;
          this.setState({
            proposalId,
            loading: false,
          });
          window.location.href = QuotationBloc.getProposalSubmissionUrl(
            proposalId,
            quotationId
          );
        }
      })
      .catch((e) => {
        ProposalBloc.getProposalByQuotationId(quotationId)
          .then((result) => {
            let proposalId = result;
            this.setState({
              loading: false,
            });
            window.location.href = QuotationBloc.getProposalSubmissionUrl(
              proposalId,
              quotationId
            );
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
          });
      });
  }

  async onDelete() {
    let id = this.stateItemId();
    this.setState({
      loading: true,
    });
    let payload = {
      "quotationIds": this.props.quotationIds || [],
      "proposalIds": this.props.proposalIds || []
    }
    ContactBloc.deleteContactById(id, payload).then((result) => {
      if (result.success) {
        this.setState({
          loading: false,
          isOpenDeleteDialog: false
        });
        if (this.props.refresh) {
          this.props.refresh();
        }
      }
    }).catch(e => {
      console.log("Api Error");
    })
  }

  getLabelsDeleteDialog() {
    return [
      "LBL_CONTACT_DELETE_DIALOG_TITLE",
      "LBL_CONTACT_DELETE_DIALOG_DESC",
      "LBL_CONTACT_DELETE_YES"
    ];
  }

  openDeleteDialog() {
    this.setState({
      isOpenDeleteDialog: true
    })
  }

  onCloseDeleteDialog() {
    this.setState({
      isOpenDeleteDialog: false
    })
  }

  onActionButtonDialog(e) {
    if (e == "yes") {
      this.onDelete();
    } else {
      this.onCloseDeleteDialog();
    }
  }

  async createNewQuotation() {
    let clientId = this.stateItemId()
    let payload = {
      clientId: clientId
    }
    let result = await QuotationBloc.createNewQuotation(payload);
    window.location.href = `/${Config.context}/${Config.routes.generic.quotation_personal_details}/${result}/${clientId}`;
  }

  async getTrackErrorsDetails() {
    let fileId = this.stateItemId();
    let result = await AdminBloc.getTrackErrorsDetails(fileId);
    if (result.success) {
      let data = result.data;
      console.log("DATATATAT",data)
      this.setState({
        isOpenTrackDialog: true,
        trackErrorsList: data,
        fileName: ""
      })

    } else {
      this.setState({
        data: [],
        isLoading: false,
        currentPage: null,
        pageCount: null,
      });
    }
  }

  getActions() {
    let allowedToDelete = this.props.allowedToDelete || false
    let labels = Config[this.stateModule()].actions[this.stateStatus()].labels;
    let links = Config[this.stateModule()].actions[this.stateStatus()].urls;
    let items = [];

    labels = labels.filter(function (item) {
      return item !== (allowedToDelete == false ? "Delete" : "")
    })

    links = links.filter(function (item) {
      return item !== (allowedToDelete == false ? "/" : "")
    })

    labels.forEach((item, idx) => {
      let record = {};
      record = {
        label: (
          <>
            <div
              onClick={(e) => {
                e.stopPropagation();
                /* if (item == "Delete") {
                  this.openDeleteDialog();
                } else if (item == "Generate Quotation") {
                  this.createNewQuotation()
                } else if (item == "View Transactions") {
                  window.location.href = `/${Config.context}/${"contact/view/transactions"
                    }/${this.stateItemId()}`;
                } else {
                  window.location.href = `/${Config.context}/${links[idx]
                    }/${this.stateItemId()}`;
                } */
                if (item == "View/Update") {
                  window.location.href = `/${Config.context}/${links[idx]}/${this.stateItemId()}`;
                }

                if (item == "View Uploaded File") {
                  window.location.href = `/${Config.context}/${links[idx]}/${this.stateItemId()}`;
                }

                if (item == "Delete File") {
                  this.setState({
                    openDeleteSignatureDialog: true,
                    deleteSignatureDialogTitle: "Delete File Upload",
                    deleteSignatureDialogDesc: "Kindly provide details for the deletion.",
                  })
                }

                if (item == "Track Errors") {
                  this.getTrackErrorsDetails()
                }

              }}
              className={`dropdown-action-item 
              ${idx == 0 ? `dropdown-action-first-item` : null}
                ${idx == labels.length - 1 ? `dropdown-action-last-item` : null}
              `}
              style={{ width: 250 }}
            >
              {item}
            </div>
          </>
        ),
        key: idx,
      };

      items.push(record);
      if (idx != labels.length - 1) {
        items.push({
          type: "divider",
        });
      }
    });
    return { items };
  }

  stateIsOpenTrackDialog() {
    return this.state.isOpenTrackDialog
  }

  async deleteFileUpload() {
    await AdminBloc.deleteFileUpload(this.stateItemId()).then(async (result) => {
      if (result.success) {
        //window.location.reload();
        this.setState({
          openNoticeDialog: true,
          titleNoticeDialog: "Note",
          descriptionNoticeDialog: `File Upload is deleted successfully`
        })
      } else {
        this.setState({
          loading: false,
          openNoticeDialog: true,
          titleNoticeDialog: "Error",
          descriptionNoticeDialog: `File Upload  is not deleted successfully`
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
      })
    })
  }

  render() {
    return (
      <>
        <AppDialog
          isOpen={this.state.openNoticeDialog}
          title={this.state.titleNoticeDialog}
          description={this.state.descriptionNoticeDialog}
          buttonLabel={null}
          onClick={(e) => {
            window.location.reload();
          }}
        />

        <AppDeleteSignatureDialog
          isOpen={this.state.openDeleteSignatureDialog}
          title={this.state.deleteSignatureDialogTitle}
          subTitle={this.state.deleteSignatureDialogDesc}
          compulsory={true}
          negativeButton={"Close"}
          positiveButton={"Confirm"}
          showComment={true}
          roleList={this.state.roleList}
          onCloseDialog={(e) => {
            if (e == "yes") {
              this.setState({
                loading: true,
                openDeleteSignatureDialog: false,
              }, () => {
                this.deleteFileUpload()
              })

            } else {
              this.setState({
                openDeleteSignatureDialog: false
              })
            }
          }}
        />
        <AppTrackDialog
          key={this.state.isOpenTrackKey}
          isOpen={this.stateIsOpenTrackDialog()}
          title={"Track Errors"}
          showClose={true}
          id={this.state.id}
          subTitle={
            ""
          }
          fileName={this.state.fileName}
          trackErrorsList={this.state.trackErrorsList}
          onCloseDialog={(e) => {
            this.setState({
              isOpenTrackDialog: false
            })
          }}
        />
        <App_notice_dialog
          isOpen={this.stateIsOpenDeleteDialog()}
          title={LanguageBloc.getTextByCode(Labels[this.getLabelsDeleteDialog()[0]])}
          subTitle={
            LanguageBloc.getTextByCode(Labels[this.getLabelsDeleteDialog()[1]])
          }
          negativeButton={LanguageBloc.getTextByCode(Labels.LBL_DELETE_NO)}
          positiveButton={LanguageBloc.getTextByCode(this.getLabelsDeleteDialog()[2])}
          onCloseDialog={(e) => {
            this.onActionButtonDialog(e);
          }}
        />
        <Dropdown menu={this.getActions()} trigger={
          ["click"]
        }>
          <a onClick={(e) => e.stopPropagation()}>
            <Space>
              <img
                src={
                  this.getAssetsContextPath() + `/assets/icons/horizontalThreeDots.svg`
                }
                alt="View More"
              />
            </Space>
          </a>
        </Dropdown>
      </>
    );
  }
}
